

export const squareButtons = [{
  id: '1',
  icon: 'icon_generalcalculation-square1',
  tooltip:"TT104",//APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 1,
    m: 1
  }
}, {
  id: '2',
  icon: 'icon_generalcalculation-square2',
  tooltip: "TT104", //APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 2,
    m: 1
  }
}, {
  id: '3',
  icon: 'icon_generalcalculation-square3',
  tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 3,
    m: 1
  }
}, {
  id: '4',
  icon: 'icon_generalcalculation-square4',
  tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 2,
    m: 2
  }
}, {
  id: '5',
  icon: 'icon_generalcalculation-square6',
  tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 3,
    m: 2
  },
  padding: {
    s1: 111,
    s2: 222
  }
}, {
  id: '6',
  icon: 'icon_generalcalculation-square8',
  tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SQUARE.Content,
  count: {
    n: 3,
    m: 3
  },
  ignore: [{ n: 2, m: 2 }]
}, {
  id: '7',
  icon: 'icon_generalcalculation-squaren',
  tooltip:"TT105", //APP_TOOLTIPS.TOOLTIP_CUSTOMISE_LAYOUT_SQUARE.Content,
  withInput: true
}];

export const circleButtons = [{
  id: '1',
  icon: 'icon_generalcalculation-round1',
  tooltip:"TT106", //APP_TOOLTIPS.TOOLTIP_CIRCULAR_BASE_PLATE.Content,
  count: 1
}, {
  id: '2',
  icon: 'icon_generalcalculation-round2',
  tooltip:"TT106",//APP_TOOLTIPS.TOOLTIP_CIRCULAR_BASE_PLATE.Content,
  count: 2
}, {
  id: '3',
  icon: 'icon_generalcalculation-round3',
  tooltip:"TT106", //APP_TOOLTIPS.TOOLTIP_CIRCULAR_BASE_PLATE.Content,
  count: 3
}, {
  id: '4',
  icon: 'icon_generalcalculation-round4',
  tooltip:"TT106", //APP_TOOLTIPS.TOOLTIP_CIRCULAR_BASE_PLATE.Content,
  count: 4
}, {
  id: '5',
  icon: 'icon_generalcalculation-round6',
  tooltip:"TT106", //APP_TOOLTIPS.TOOLTIP_CIRCULAR_BASE_PLATE.Content,
  count: 6
}, {
  id: '6',
  icon: 'icon_generalcalculation-roundn',
  tooltip:"TT107", //APP_TOOLTIPS.TOOLTIP_CUSTOMISE_LAYOUT_CIRCLE.Content,
  withInput: true
}];

export const triangleButtons = [{
  id: '1',
  icon: 'icon_generalcalculation-triangle1',
  tooltip:"TT108", //APP_TOOLTIPS.TOOLTIP_TRIANGULAR_BASE_PLATE.Content,
  count: {
    n: 1,
  }
}, {
  id: '2',
  icon: 'icon_generalcalculation-triangle2',
  tooltip:"TT108", //APP_TOOLTIPS.TOOLTIP_TRIANGULAR_BASE_PLATE.Content,
  count: {
    n: 2
  }
}, {
  id: '3',
  icon: 'icon_generalcalculation-triangle3',
  tooltip:"TT108", //APP_TOOLTIPS.TOOLTIP_TRIANGULAR_BASE_PLATE.Content,
  count: {
    n: 3
  }
}, {
  id: '4',
  icon: 'icon_generalcalculation-trianglen',
  tooltip:"TT109", //APP_TOOLTIPS.TOOLTIP_CUSTOMISE_LAYOUT_TRIANGLE.Content,
  withInput: true
}];



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/initialState-general-calculation.js